// extracted by mini-css-extract-plugin
export default {"main":"register_main__4Gw6x","box":"register_box__a6uqI","icon":"register_icon__jZNoI"};